import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { io } from 'socket.io-client';

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const COLORS = ['#512e5f', '#76448a', '#884ea0', '#9b59b6', '#a569bd', '#c39bd3', '#d7bde2'];
const MACHINES = ['Machine1', 'Machine2', 'Machine3', 'Machine4', 'Machine5', 'Machine6', 'Machine7'];
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://pochelo.online';

const BarPromedioRPM = () => {
  const [chartData, setChartData] = useState({
    labels: MACHINES,
    datasets: []
  });

  useEffect(() => {
  const socket = io(SOCKET_URL);

  // Al montar, intenta cargar datos previos
  const cached = localStorage.getItem('promedioRPMTiempoReal');
  if (cached) {
    setChartData(JSON.parse(cached));
  }

  socket.on('promedioRPMTiempoReal', (result) => {
    const dataDict = {};
    result.forEach(item => {
      dataDict[item.maquinaId] = item.promedioRPM || 0;
    });
    const data = MACHINES.map(id => dataDict[id] || 0);

    const chart = {
      labels: MACHINES,
      datasets: [
        {
          label: 'Promedio RPM Tiempo Real',
          data,
          backgroundColor: COLORS,
          borderRadius: 2,
        }
      ]
    };
    setChartData(chart);
    localStorage.setItem('promedioRPMTiempoReal', JSON.stringify(chart));
  });

  return () => {
    socket.disconnect();
  };
}, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        labels: { color: '#8ab0cc', font: { family: 'Roboto', size: 9 } }
      },
      title: {
        display: true,
        text: 'Promedio de Revoluciones por Máquina (Tiempo Real)',
        color: '#8ab0cc',
        font: { family: 'Roboto', size: 10 }
      }
    },
    scales: {
      x: {
        grid: { color: 'rgba(30,90,180,0.2)', lineWidth: 0.5 },
        ticks: { color: '#8ab0cc', font: { family: 'Roboto', size: 10 } }
      },
      y: {
        grid: { color: 'rgba(30,90,180,0.2)', lineWidth: 0.5 },
        ticks: { color: '#8ab0cc', font: { family: 'Roboto', size: 10 } }
      }
    },
    animation: {
      duration: 1500,
      easing: 'easeInOutQuart'
    }
  };

  return (
    <Bar data={chartData} options={options} height={280} />
  );
};

export default BarPromedioRPM;